import PropTypes from 'prop-types';

import StockIssueCommandBar from './StockIssueCommandBar';
import StockIssueDetailSection from './StockIssueDetailSection';
import StockIssueMainInfoCard from './StockIssueMainInfoCard';

const StockIssueBlock = ({
  detail,
  defaultOpen = true,
  onRefetch,
  showActions = false,
}) => (
  <div className="receipt-card-elevate">
    <div className="receipt-card-surface">
      <StockIssueMainInfoCard
        detail={detail}
        embedded
        actions={
          showActions ? (
            <StockIssueCommandBar
              key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
              detail={detail}
              onRefetch={onRefetch}
            />
          ) : null
        }
      />
      <StockIssueDetailSection detail={detail} embedded defaultOpen={defaultOpen} />
    </div>
  </div>
);

StockIssueBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    issueNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  defaultOpen: PropTypes.bool,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default StockIssueBlock;
